module.exports = __webpack_public_path__ + "img/icon_map_11_on_100.0aa79922.png";